import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueI18n from 'vue-i18n'
import vuetify from './plugins/vuetify'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'

Vue.use(VueI18n)
const messages = {
  en: {
    message: {
      languageFullName: 'English'
    }
  },
  de: {
    message: {
      languageFullName: 'German'
    }
  },
  fr: {
    message: {
      languageFullName: 'French'
    }
  },
  fi: {
    message: {
      languageFullName: 'Finnish'
    }
  },
  da: {
    message: {
      languageFullName: 'Danish'
    }
  },
  cs: {
    message: {
      languageFullName: 'Czech'
    }
  },
  es: {
    message: {
      languageFullName: 'Spanish'
    }
  },
  it: {
    message: {
      languageFullName: 'Italian'
    }
  },
  nl: {
    message: {
      languageFullName: 'Dutch'
    }
  },
  nb: {
    message: {
      languageFullName: 'Norwegian'
    }
  },
  ru: {
    message: {
      languageFullName: 'Russian'
    }
  },
  zhHANS: {
    message: {
      languageFullName: 'Chinese simple'
    }
  },
  zhHANT: {
    message: {
      languageFullName: 'Chinese traditional'
    }
  },
  ko: {
    message: {
      languageFullName: 'Korean'
    }
  },
  pl: {
    message: {
      languageFullName: 'Polish'
    }
  },
  sk: {
    message: {
      languageFullName: 'Slovak'
    }
  },
  sv: {
    message: {
      languageFullName: 'Swedish'
    }
  },
  tr: {
    message: {
      languageFullName: 'Turkish'
    }
  },
  ar: {
    message: {
      languageFullName: 'Arabic'
    }
  },
  pt: {
    message: {
      languageFullName: 'Portuguese'
    }
  },
  el: {
    message: {
      languageFullName: 'Greek'
    }
  },
  sl: {
    message: {
      languageFullName: 'Slovenian'
    }
  },
  hu: {
    message: {
      languageFullName: 'Hungarian'
    }
  },
  ro: {
    message: {
      languageFullName: 'Romanian'
    }
  },
  bg: {
    message: {
      languageFullName: 'Bulgarian'
    }
  },
  id: {
    message: {
      languageFullName: 'Indonesian'
    }
  },
  'en-US': {
    message: {
      languageFullName: 'English - United States'
    }
  },
  'es-US': {
    message: {
      languageFullName: 'Spanish - United States'
    }
  },
  'en-CA': {
    message: {
      languageFullName: 'English - Canada'
    }
  },
  'fr-CA': {
    message: {
      languageFullName: 'French - Canada'
    }
  },
  'th-TH': {
    message: {
      languageFullName: 'Thai - Thailand'
    }
  }
}

const i18n = new VueI18n({
  locale: 'en', // set locale
  messages // set locale messages
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: h => h(App)
}).$mount('#app')
